/* =========================================================
   LOGIN WARRANTY CLAIM
   API + FORM + FAQ + FILE NAME
========================================================= */

document.addEventListener("DOMContentLoaded", function () {
  "use strict";

  /* =======================================================
     FORM
  ======================================================= */

  const form = document.getElementById("warrantyClaimForm");

  if (!form) {
    return;
  }


  /* =======================================================
     API
  ======================================================= */

  const API_URL =
    form.dataset.apiUrl ||
    "https://data.login.com.pk/warranty-claim-api/warranty-claim.php";


  /* =======================================================
     ELEMENTS
  ======================================================= */

  const messageBox = form.querySelector("[data-form-message]");
  const submitButton = form.querySelector(
    ".login-warranty-claim__submit"
  );

  const submitText = form.querySelector(
    ".login-warranty-claim__submit-text"
  );

  const fileInput = document.getElementById("claim-media");

  const fileNameElement = form.querySelector(
    "[data-file-name]"
  );


  /* =======================================================
     MESSAGE
  ======================================================= */

  function showMessage(message, type) {

    if (!messageBox) {
      return;
    }

    messageBox.textContent = message;

    messageBox.classList.remove(
      "is-success",
      "is-error",
      "is-loading"
    );

    if (type === "success") {
      messageBox.classList.add("is-success");
    }

    if (type === "error") {
      messageBox.classList.add("is-error");
    }

    if (type === "loading") {
      messageBox.classList.add("is-loading");
    }

  }


  function clearMessage() {

    if (!messageBox) {
      return;
    }

    messageBox.textContent = "";

    messageBox.classList.remove(
      "is-success",
      "is-error",
      "is-loading"
    );

  }


  /* =======================================================
     FIELD ERROR
  ======================================================= */

  function clearFieldErrors() {

    const fields = form.querySelectorAll(
      "input, select, textarea"
    );

    fields.forEach(function (field) {
      field.classList.remove("is-error");
    });

  }


  function markFieldError(field) {

    if (!field) {
      return;
    }

    field.classList.add("is-error");
  }


  /* =======================================================
     VALIDATION
  ======================================================= */

  function validateForm() {

    clearFieldErrors();

    let valid = true;

    const requiredFields = form.querySelectorAll(
      "input[required], select[required], textarea[required]"
    );

    requiredFields.forEach(function (field) {

      /*
       * Checkbox
       */
      if (field.type === "checkbox") {

        if (!field.checked) {
          markFieldError(field);
          valid = false;
        }

        return;
      }


      /*
       * File
       */
      if (field.type === "file") {

        if (!field.files || field.files.length === 0) {
          markFieldError(field);
          valid = false;
        }

        return;
      }


      /*
       * Normal fields
       */
      if (!field.value.trim()) {
        markFieldError(field);
        valid = false;
      }

    });


    /*
     * Email validation
     */
    const emailField = document.getElementById("claim-email");

    if (emailField && emailField.value.trim()) {

      const emailPattern =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailPattern.test(emailField.value.trim())) {

        markFieldError(emailField);

        showMessage(
          "Please enter a valid email address.",
          "error"
        );

        return false;
      }

    }


    /*
     * File validation
     */
    if (fileInput && fileInput.files.length > 0) {

      const file = fileInput.files[0];

      const maxFileSize = 20 * 1024 * 1024; // 20MB

      if (file.size > maxFileSize) {

        markFieldError(fileInput);

        showMessage(
          "File size must be 20MB or less.",
          "error"
        );

        return false;
      }


      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/webp",
        "image/gif",
        "video/mp4",
        "video/webm",
        "video/quicktime",
        "video/x-msvideo"
      ];


      if (
        file.type &&
        !allowedTypes.includes(file.type)
      ) {

        markFieldError(fileInput);

        showMessage(
          "Please upload a valid image or video file.",
          "error"
        );

        return false;
      }

    }


    if (!valid) {

      showMessage(
        "Please complete all required fields.",
        "error"
      );

      const firstError = form.querySelector(
        ".is-error"
      );

      if (firstError) {

        firstError.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

      }

      return false;
    }


    return true;
  }


  /* =======================================================
     FILE NAME
  ======================================================= */

  if (fileInput) {

    fileInput.addEventListener(
      "change",
      function () {

        if (!fileNameElement) {
          return;
        }

        if (
          this.files &&
          this.files.length > 0
        ) {

          fileNameElement.textContent =
            this.files[0].name;

        } else {

          fileNameElement.textContent =
            "No file chosen";

        }

      }
    );

  }


  /* =======================================================
     REMOVE FIELD ERROR WHEN USER STARTS TYPING
  ======================================================= */

  const fields = form.querySelectorAll(
    "input, select, textarea"
  );

  fields.forEach(function (field) {

    field.addEventListener(
      "input",
      function () {
        this.classList.remove("is-error");
      }
    );

    field.addEventListener(
      "change",
      function () {
        this.classList.remove("is-error");
      }
    );

  });


  /* =======================================================
     FORM SUBMIT
  ======================================================= */

  form.addEventListener(
    "submit",
    async function (event) {

      event.preventDefault();

      clearMessage();

      /*
       * Validate
       */
      if (!validateForm()) {
        return;
      }


      /*
       * Disable submit button
       */
      submitButton.disabled = true;

      submitButton.classList.add(
        "is-loading"
      );


      if (submitText) {

        submitText.textContent =
          "Submitting...";

      }


      showMessage(
        "Submitting your warranty claim...",
        "loading"
      );


      /*
       * FormData
       */
      const formData = new FormData(form);


      /*
       * Make sure terms value exists
       */
      if (!formData.get("terms")) {

        formData.set(
          "terms",
          "accepted"
        );

      }


      try {

        /* =================================================
           API REQUEST
        ================================================= */

        const response = await fetch(
          API_URL,
          {
            method: "POST",
            body: formData
          }
        );


        /*
         * Get response as text first.
         *
         * This helps us handle PHP errors
         * where the server may return HTML
         * instead of JSON.
         */

        const responseText =
          await response.text();


        let result = null;


        try {

          result =
            JSON.parse(responseText);

        } catch (jsonError) {

          console.error(
            "Invalid JSON response from API:",
            responseText
          );

          throw new Error(
            "The server returned an invalid response."
          );

        }


        /*
         * HTTP error
         */

        if (!response.ok) {

          throw new Error(
            result.message ||
            "Unable to submit your warranty claim."
          );

        }


        /*
         * API returned failure
         */

        if (!result.success) {

          throw new Error(
            result.message ||
            "Your warranty claim could not be submitted."
          );

        }


        /* =================================================
           SUCCESS
        ================================================= */

        let successMessage =
          result.message ||
          "Your warranty claim has been submitted successfully.";


        /*
         * Claim reference
         */

        if (result.claim_reference) {

          successMessage +=
            " Claim Reference: " +
            result.claim_reference;

        }


        showMessage(
          successMessage,
          "success"
        );


        /*
         * Reset form
         */

        form.reset();


        /*
         * Reset file name
         */

        if (fileNameElement) {

          fileNameElement.textContent =
            "No file chosen";

        }


        /*
         * Remove errors
         */

        clearFieldErrors();


        /*
         * Reset button
         */

        submitButton.disabled = false;

        submitButton.classList.remove(
          "is-loading"
        );


        if (submitText) {

          submitText.textContent =
            "Submit Complaint";

        }


        /*
         * Scroll to success message
         */

        if (messageBox) {

          messageBox.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });

        }

      } catch (error) {

        console.error(
          "Warranty Claim API Error:",
          error
        );


        /* ===============================================
           ERROR
        =============================================== */

        showMessage(
          error.message ||
          "Something went wrong. Please try again or contact support.",
          "error"
        );


        /*
         * Enable button again
         */

        submitButton.disabled = false;

        submitButton.classList.remove(
          "is-loading"
        );


        if (submitText) {

          submitText.textContent =
            "Submit Complaint";

        }

      }

    }
  );


  /* =======================================================
     FAQ ACCORDION
  ======================================================= */

  const faqQuestions =
    document.querySelectorAll(
      ".login-warranty-claim__faq-question"
    );


  faqQuestions.forEach(function (question) {

    question.addEventListener(
      "click",
      function () {

        const currentItem =
          this.closest(
            ".login-warranty-claim__faq-item"
          );

        if (!currentItem) {
          return;
        }


        const isOpen =
          currentItem.classList.contains(
            "is-open"
          );


        /*
         * Close all other FAQs
         */

        document
          .querySelectorAll(
            ".login-warranty-claim__faq-item.is-open"
          )
          .forEach(function (item) {

            if (item !== currentItem) {

              item.classList.remove(
                "is-open"
              );

              const btn =
                item.querySelector(
                  ".login-warranty-claim__faq-question"
                );

              if (btn) {

                btn.setAttribute(
                  "aria-expanded",
                  "false"
                );

              }

            }

          });


        /*
         * Toggle current FAQ
         */

        if (isOpen) {

          currentItem.classList.remove(
            "is-open"
          );

          this.setAttribute(
            "aria-expanded",
            "false"
          );

        } else {

          currentItem.classList.add(
            "is-open"
          );

          this.setAttribute(
            "aria-expanded",
            "true"
          );

        }

      }
    );

  });


  /* =======================================================
     DEBUG
  ======================================================= */

  console.log(
    "Login Warranty Claim initialized."
  );

  console.log(
    "Warranty Claim API:",
    API_URL
  );

});